define('views/blocks/CustomerServiceBoxView',['underscore',
        'jquery',
        'backbone',
        'app',
        'template!blocks/customer-service-box',
	],
    function (_,
              $,
              Backbone,
              app,
              customerServiceBoxTemplate
    ) {


    var self;

    return Backbone.View.extend({

        events: {
            'click .btn-close': 'hide'
        },
        initialize:function(){

            self = this;
            self.render(false);

        },

        render:function(ignoreRetemplating){

                $('.site').append(customerServiceBoxTemplate());
                this.setElement($('.customer-service-box'));

        },

        hide: function(){
            this.remove();
        }

    });
});
